import './StatusBadges.css';

interface StatusBadgeProps {
    estado: number;
    label: string;
}


export function StatusBadge({
    estado,
    label,
}: StatusBadgeProps) {
    return (
        <span
            className={`estado-${estado}`}
        >
            {label}
        </span>
    );
}